/** @flow */

import React from "react";
import { connect } from "react-redux";
import { Switch, Route, Redirect } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
import { isAuthChecked, isAuthenticated } from "@modules/account/selectors";
import { Loader } from "@components";
import type { State } from "@store/reducers";

import PrivateRoute from "./private-route";
import Pages from "./pages";
import * as Paths from "./constants";
import { isStaticPage } from "@selectors/index";
import { MANAGEMENT_CONTACT_CENTRE_SERVICE_DESK_MANAGEMENT_PATH } from "./constants";

type OwnProps = {|
  history: Object,
|};

type PropsFromState = {|
  isLoading: boolean,
  isAuthenticated: boolean,
|};

type Props = OwnProps & PropsFromState;

const Router = ({ history, isLoading, isAuthenticated }: Props) => {
  return (isStaticPage() ? (
    false
  ) : (
    isLoading
  )) ? (
    <Loader />
  ) : (
    <ConnectedRouter history={history}>
      <Switch>
        {/* Public routes */}
        <Route path={Paths.LOGIN_PATH} component={Pages.IncomingCallPage} exact />
        <Route path={Paths.REGISTRATION_PATH} component={Pages.Registration} exact />
        <Route path={Paths.PASSWORD_SET_PATH} component={Pages.SetPassword} exact />
        <Route path={Paths.NOT_FOUND_PATH} component={Pages.Error404} exact />
        <Route path={Paths.SERVICE_UNAVAILABLE_PATH} component={Pages.ServiceUnavailable} exact />
        <Route path={Paths.NO_ACCESS_PATH} component={Pages.NoAccessPage} exact />
        <PrivateRoute
          isAuthenticated={isAuthenticated}
          path={Paths.HOME_PATH}
          component={Pages.IncomingCallPage}
          exact
        />
        {/* Recording */}
        <PrivateRoute
          isAuthenticated={isAuthenticated}
          path={Paths.RECORDING_PATH}
          component={Pages.IncomingCallPage}
          exact
        />
        <PrivateRoute
          isAuthenticated={isAuthenticated}
          path={Paths.RECORDING_PATH_INBOUND_CALLS}
          component={Pages.IncomingCallPage}
          exact
        />
        <PrivateRoute
          isAuthenticated={isAuthenticated}
          path={Paths.RECORDING_CALLBACK_PATH}
          component={Pages.IncomingCallPage}
          exact
        />
        <PrivateRoute
          isAuthenticated={isAuthenticated}
          path={Paths.RECORDING_OUTBOUND_CALLS_PATH}
          component={Pages.OutboundCallsPage}
          exact
        />

        {/* Management */}
        <PrivateRoute
          isAuthenticated={isAuthenticated}
          path={Paths.MANAGEMENT_PATH}
          component={Pages.ManagementPage}
          exact
        />
        <PrivateRoute
          isAuthenticated={isAuthenticated}
          path={Paths.MANAGEMENT_CONTACT_CENTRE_DASHBOARD_PATH}
          component={Pages.ContactCentreDashboardPage}
          exact
        />
        <PrivateRoute
          isAuthenticated={isAuthenticated}
          path={Paths.MANAGEMENT_CONTACT_CENTRE_QUEUE_MANAGEMENT_PATH}
          component={Pages.QueueManagementPage}
          exact
        />
        <PrivateRoute
          isAuthenticated={isAuthenticated}
          path={Paths.MANAGEMENT_CONTACT_CENTRE_SCRIPT_MANAGEMENT_PATH}
          component={Pages.ScriptManagementPage}
          exact
        />
        <PrivateRoute
          isAuthenticated={isAuthenticated}
          path={Paths.MANAGEMENT_SYSTEM_MESSAGES_PATH}
          component={Pages.ManagementMessagesPage}
          exact
        />

        <PrivateRoute
          isAuthenticated={isAuthenticated}
          path={Paths.HEALTH_NOTICES_MANAGEMENT_PATH}
          component={Pages.HealthNoticesPage}
          exact
        />

        <PrivateRoute
          isAuthenticated={isAuthenticated}
          path={Paths.MANAGEMENT_IMAGE_LIBRARY_PATH}
          component={Pages.ImageLibraryPage}
          exact
        />

        <PrivateRoute
          isAuthenticated={isAuthenticated}
          path={Paths.MANAGEMENT_CLINICAL_GOVERNANCE_INCIDENT_REGISTER_PATH}
          component={Pages.IncidentRegisterPage}
          exact
        />

        <PrivateRoute
          isAuthenticated={isAuthenticated}
          path={Paths.MANAGEMENT_CLINICAL_GOVERNANCE_INCIDENT_RATES_REPORT_PATH}
          component={Pages.IncidentRatesReportPage}
          exact
        />
        <PrivateRoute
          isAuthenticated={isAuthenticated}
          path={Paths.MANAGEMENT_CLASSIFICATIONS_PATH}
          component={Pages.ClassificationsPage}
          exact
        />
        <PrivateRoute
          isAuthenticated={isAuthenticated}
          path={Paths.MANAGEMENT_INTERVENTIONS_PATH}
          component={Pages.InterventionsPage}
          exact
        />

        <PrivateRoute
          isAuthenticated={isAuthenticated}
          path={Paths.MANAGEMENT_CONTACT_CENTRE_SERVICE_DESK_MANAGEMENT_PATH}
          component={Pages.ServiceDeskManagementPage}
          exact
        />

        <Redirect to={Paths.NOT_FOUND_PATH} />
      </Switch>
    </ConnectedRouter>
  );
};

const mapStateToProps = (state: State): PropsFromState => ({
  isLoading: !isAuthChecked(state),
  isAuthenticated: isAuthenticated(state),
});

export default connect(mapStateToProps)(Router);
